import { Tabs as ArkTabs } from '@ark-ui/react';

import { cn } from '../../lib/utils';

type TabsRootProps = ArkTabs.RootProps;
type TabsRootProviderProps = ArkTabs.RootProviderProps;
type TabsListProps = ArkTabs.ListProps;
type TabsTriggerProps = ArkTabs.TriggerProps;
type TabsContentProps = ArkTabs.ContentProps;
type TabsIndicatorProps = ArkTabs.IndicatorProps;

function TabsRoot({ className, ...props }: TabsRootProps) {
	return <ArkTabs.Root className={cn('pt-tabs', className)} {...props} />;
}

function TabsRootProvider({ ...props }: TabsRootProviderProps) {
	return <ArkTabs.RootProvider {...props} />;
}

function TabsList({ className, ...props }: TabsListProps) {
	return <ArkTabs.List className={cn('pt-tabs-list', className)} {...props} />;
}

function TabsTrigger({ className, ...props }: TabsTriggerProps) {
	return <ArkTabs.Trigger className={cn('pt-tabs-trigger', className)} {...props} />;
}

function TabsContent({ className, ...props }: TabsContentProps) {
	return <ArkTabs.Content className={cn('pt-tabs-content', className)} {...props} />;
}

function TabsIndicator({ className, ...props }: TabsIndicatorProps) {
	return <ArkTabs.Indicator className={cn('pt-tabs-indicator', className)} {...props} />;
}

const Tabs = Object.assign(TabsRoot, {
	Root: TabsRoot,
	RootProvider: TabsRootProvider,
	List: TabsList,
	Trigger: TabsTrigger,
	Content: TabsContent,
	Indicator: TabsIndicator,
	Context: ArkTabs.Context
});

export {
	Tabs,
	type TabsRootProps,
	type TabsRootProviderProps,
	type TabsListProps,
	type TabsTriggerProps,
	type TabsContentProps,
	type TabsIndicatorProps
};
